import axios from 'axios'
import Vue from "vue";
import { Picker, Popup, Area, Icon, Uploader, Toast } from "vant";
Vue.use(Picker)
  .use(Popup)
  .use(Area)
  .use(Icon)
  .use(Uploader)
  .use(Toast);
// import router from '../router'

/*axios配置*/
let vm=this;
// 创建axios实例
const service = axios.create({
  baseURL:process.env.BASE_API, // api 的 base_url  process.env.BASE_API
  timeout: 5000 // 请求超时时间
})

service.defaults.headers.post['Content-Type'] = 'application/json';


// response拦截器
service.interceptors.response.use(
  
  response=>{
    console.log(response)
    switch(response.data.code){
      
      case 200: {
        return response.data; 
        break;
      }
      case 300: {
        return response.data; 
        break;
      }
      case 400: {
        Toast(response.data.msg);
        return response.data; 
      break;

      }
      default:return response.data;
    }

  },
  error => {
    console.log(error)
    if(error&&error.response.status){
      
      switch (error.response.status){
        case 400:
          Toast("错误请求");
          break;
        case 401:
          Toast("未授权");
          break;
        case 403:
          Toast("拒绝访问");
          break;
        case 404:
          Toast("请求错误，未找到该资源");
          break;
        case 405:
          Toast("请求方法未允许");
          break;
        case 408:
          Toast("请求超时");
          break;
        case 500:
          Toast("服务器端出错");
          break;
        case 501:
          Toast("网络未实现");
          break;
        case 502:
          Toast("网络错误");
          break;
        case 503:
          Toast("服务不可用");
          break;
        case 504:
          Toast("网络超时");
          break;
        case 505:
          Toast("网络错误");
          break;
        default:
          Toast('连接错误'+error.response.status);
      }
    }else{
      Toast("网络出现问题，请稍候再试");
    }
    return Promise.reject(error.response.data);
  }
);

export  default service



// WEBPACK FOOTER //
// ./src/libs/https.js